import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Carlos Mendes',
      role: 'Empresário - Comércio',
      avatar: 'https://images.pexels.com/photos/10375895/pexels-photo-10375895.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
      quote: 'O DRE+ mudou completamente a forma como gerencio as finanças da minha empresa. Agora tenho controle total das contas a pagar e receber. Nunca mais perdi um vencimento!',
      rating: 5,
    },
    {
      name: 'Ana Paula Silva',
      role: 'Autônoma - Consultoria',
      avatar: 'https://images.pexels.com/photos/3932718/pexels-photo-3932718.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
      quote: 'Super fácil de usar! Consigo acessar pelo celular e manter tudo organizado. O relatório DRE me ajuda muito na hora de tomar decisões no meu negócio.',
      rating: 5,
    },
    {
      name: 'Roberto Ferreira',
      role: 'Microempreendedor',
      avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
      quote: 'Finalmente encontrei uma ferramenta que me mostra de forma clara se estou tendo lucro ou prejuízo. O fluxo de caixa mensal é excelente para planejamento.',
      rating: 5,
    },
    {
      name: 'Juliana Costa',
      role: 'Empresária - Serviços',
      avatar: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&dpr=2',
      quote: 'Recomendo para todos os pequenos empresários! A interface é muito intuitiva e os relatórios são completos. Vale muito a pena.',
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="section-padding bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#D1FAE5] text-[#065F46] rounded-full text-sm font-semibold mb-4" data-testid="testimonials-badge">
            Depoimentos
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4" data-testid="testimonials-title">
            O que nossos <span className="text-[#047857]">clientes</span> dizem
          </h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto" data-testid="testimonials-description">
            Veja como o DRE+ está ajudando empresários a ter controle financeiro de verdade.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="testimonial-card"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote */}
              <p className="text-[#0F172A] text-lg leading-relaxed mb-6 relative z-10 pt-8">
                "{testimonial.quote}"
              </p>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#F59E0B] text-[#F59E0B]" />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md"
                  loading="lazy"
                />
                <div>
                  <h4 className="font-heading font-bold text-[#0F172A]">{testimonial.name}</h4>
                  <p className="text-[#64748B] text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
